import keyBy from 'lodash-es/keyBy';
import { DpNewsFeedActionKeys as keys, DpNewsFeedActionTypes, IDpNewsFeedPost } from '.';

export interface IDpNewsFeedState {
  postAccess: Record<number, string[]>;
  posts: Record<number, IDpNewsFeedPost>;
}

const initState: IDpNewsFeedState = {
  postAccess: {},
  posts: {}
};

export function dpNewsFeedReducer(
  state: IDpNewsFeedState = initState,
  action: DpNewsFeedActionTypes
): IDpNewsFeedState {
  switch (action.type) {
    case keys.SET_DP_NEWS_FEED_POST:
      return {
        ...state,
        posts: {
          ...state.posts,
          ...keyBy<IDpNewsFeedPost>(action.payload, x => x.dpNewsFeedPostId)
        }
      };
    case keys.SET_DP_POST_ACCESS:
      return {
        ...state,
        postAccess: {
          ...state.postAccess,
          [action.payload.postId]: action.payload.access
        }
      };
    default:
      return state;
  }
}
